import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { User } from '../models/user'
import { UserGateway } from './user-gateway'
import { OrgSettingsModel } from '../../org-management/models/org-settings-model'
import { AddressType } from '../../common/models/addresstype'

@Injectable()
export class NetworkUserGateway extends UserGateway {
    constructor(private http: HttpClient) {
        super()
    }

    retrieveUser(userProfileID: number): Observable<User> {
        return this.http.get<User>(`../api/UserDetailsByUserProfileID/${userProfileID}`)
    }

    retrieveAdminPersonalDetails(): Observable<User> {
        return this.http.get<User>('../api/GetAdminPersonalDetails')
    }

    isUserAuthorized(): Observable<boolean> {
        return this.http.get<boolean>('../api/IsUserAuthorized')
    }
    getFMOSettings(orgId: number): Observable<OrgSettingsModel[]> {
        let getUrl = '../api/getFMOSettings/' + orgId + '/FMO Settings'
        return this.http.get<OrgSettingsModel[]>(getUrl)
    }

    getBackGroundCheckSetting(orgId: number): Observable<OrgSettingsModel[]> {
        let getUrl = '../api/getFMOSettings/' + orgId + '/GoodStandingCheckNeeded'
        return this.http.get<OrgSettingsModel[]>(getUrl)
    }

    getInsCompValidAddressTypes(orgId: number): Observable<AddressType[]> {
        let url = '../api/getInsCompValidAddressTypes/' + orgId
        return this.http.get<AddressType[]>(url)
    }
}
